
// This component is destructured in from the buttom component
// Therefore, this component shares common props with the button component

import React, { FC } from 'react';
import styled from '@emotion/native';
import TextBase, { Props as TextProps } from '@components/1-atoms/Text';


const Container = styled.TouchableOpacity`

  flex-direction: row;
  align-items: center; // vertical alignment
  justify-content: flex-start; // horizontal alignmennt

  justify-content: flex-start;
  background-color: transparent;
  padding: 9px 6px;
  height: auto;

  ${props => props?.bg && ` background-color: ${props?.bg};`}
  ${props => props?.disabled && `
    background-color: #CCC;
    ${props?.outlined && ` background-color: transparent; `}
  `}
  
  min-height: ${({ height, ...props }: any) => `${height || props.theme.buttonHeight}px`};
`;

const TextWrapper = styled.View`
  flex: 1; 
`;

// TODO: Apply blue text color for primary button
const Text = styled(TextBase)`
  ${props =>  ` color: ${props.color || props.theme.pallete.mask}; `}
  ${(props) => props?.primary  && `color: ${props.theme.pallete.accentColor};`}
  ${props => props?.outlined && ` color: ${props.theme.pallete.accentColor}; `}
  ${props => props?.disabled && ` color: ${props.theme.pallete.white}; `}
  
  text-align: ${({ align }: any) => (align || "center")};
`;

export const Left = styled.View`
  width: 40px;

  justify-content: flex-start;
  flex-direction: column;
  flex-direction: row;
  text-align: left;
  padding-right: 9px;

  align-items: flex-start;
`;

export const Right = styled.View`
  justify-content: flex-end;
  flex-direction: column;
  text-align: right;
  padding-left: 9px;

  align-items: flex-end;

`;

export type Props = TextProps & {
  onPress?: () => void;
  onFocus?: () => void;
  left?: any;
  right?: any;
  height?: number;
  bg?: string;
  primary?: boolean;
  fullwidth?: boolean;
  inset?: boolean;
  outlined?: boolean;
  disabled?: boolean;
  color?: string;
  children: React.ReactNode | Text;
};


const Button: FC<Props> = ({ onPress, left, right, children, ...props }) => {
  return (
    <Container onPress={! props.disabled && onPress} fullwidth={false} {...props}>
      {left && <Left>{left}</Left>}

      <TextWrapper>
        <Text {...props}>{children}</Text>
      </TextWrapper>

      {right && <Right>{right}</Right>}
    </Container>
  );
};

export default Button;